import { render, staticRenderFns } from "./informationTaxation.vue?vue&type=template&id=2ccf9e95&scoped=true&"
import script from "./informationTaxation.vue?vue&type=script&lang=js&"
export * from "./informationTaxation.vue?vue&type=script&lang=js&"
import style0 from "./informationTaxation.vue?vue&type=style&index=0&id=2ccf9e95&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf9e95",
  null
  
)

export default component.exports